/* eslint-disable no-nested-ternary */
import { TableSettings } from 'components/TableSettings';
import { TotalCount } from 'components/TotalCount';
import { PriceListTableCount } from 'components/TotalCount/PriceListTableCount';
import { Button, cnMixSpace, Grid, GridItem } from 'uikit';

import type { AgGridReact } from 'ag-grid-react';
import type { CSSProperties, ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';

import Styles from './tableTopPanel.module.css';

interface ITableTopPanel {
    children?: ReactNode;
    checkedRowsArr?: any[];
    resetCheckedRows?: () => void;
    totalItems?: number;
    fetchedItems?: number;
    optionalColumns?: any[];
    handleTableSettingsConfirm?: (s: Record<string, boolean>) => void;
    isColumnVisible?: (t: string) => boolean;
    showCheckedOnly?: boolean;
    style?: CSSProperties;
    areChildrenOnLeftSide?: boolean;
    showPinColumn?: boolean;
    tableApi?: AgGridReact | null;
    leftSide?: ReactNode;
}

export const TableTopPanel = forwardRef((props: ITableTopPanel, ref: ForwardedRef<HTMLDivElement | null>) => {
    const {
        children,
        checkedRowsArr,
        resetCheckedRows,
        totalItems,
        fetchedItems,
        optionalColumns,
        handleTableSettingsConfirm,
        isColumnVisible,
        showCheckedOnly,
        style,
        areChildrenOnLeftSide,
        showPinColumn,
        tableApi,
        leftSide,
    } = props;

    return (
        <Grid className={cnMixSpace({ mB: 'xs' })} cols={2} yAlign="center" style={style} ref={ref}>
            <GridItem>
                {leftSide}
                {checkedRowsArr?.length ? (
                    <Grid style={{ display: 'flex' }} cols={6} yAlign="center">
                        <TotalCount
                            className={Styles.TotalCount}
                            totalCount={checkedRowsArr.length}
                            forms={['строка', 'строки', 'строк']}
                            prefix={checkedRowsArr.length > 1 ? 'Выбрано' : 'Выбрана'}
                        />
                        <GridItem style={{ display: 'flex' }}>
                            {areChildrenOnLeftSide && children}
                            <Button label="Сбросить" view="ghost" size="xs" onClick={resetCheckedRows} />
                            {!areChildrenOnLeftSide && children}
                        </GridItem>
                    </Grid>
                ) : !showCheckedOnly ? (
                    <PriceListTableCount totalItems={totalItems} totalCount={fetchedItems} />
                ) : (
                    <div />
                )}
            </GridItem>

            {optionalColumns && handleTableSettingsConfirm && isColumnVisible && (
                <GridItem style={{ display: 'flex', justifyContent: 'right' }}>
                    <TableSettings
                        columns={optionalColumns}
                        onConfirm={handleTableSettingsConfirm}
                        isColumnVisible={isColumnVisible}
                        showPinColumn={showPinColumn}
                        tableApi={tableApi}
                    />
                </GridItem>
            )}
        </Grid>
    );
});

TableTopPanel.displayName = 'TableTopPanel';
